import type { CustomIconProps } from '../CustomIcon';

export const PlusIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
    <g id='24/plus'>
      <path
        id='Vector'
        d='M12 5V19'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        id='Vector_2'
        d='M5 12H19'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);
